import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import SelectRow from "../../components/Select/SelectRow";

export default class CityAreaAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      name: "",
      city: "",
      citylist: [],
      loading: false,
    };
    this.pathname = "areas";
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const edit = this.props.location.data;
    if (edit) {
      this.setState({
        ...edit,
        city: edit.city && edit.city.id,
      });
    }
    this.prepareData();
  }

  async prepareData() {
    let responseuni = await this.engine.getItemlistDirect("cities");
    if (responseuni) {
      const data = responseuni.data.items;
      let citylist = [];
      data.map((p) => {
        citylist.push({ value: p.id, label: p.name });
      });
      this.setState({
        citylist,
      });
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, ...data } = this.state;
    let response;

    try {
      if (id) {
        response = await this.engine.updateItem(this.pathname, id, data);
      } else {
        response = await this.engine.saveItem(this.pathname, data);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push("/admin/" + this.pathname);
      }
    } catch (err) {
      const errorMessageArray = err.response?.data?.message;

      if (errorMessageArray && Array.isArray(errorMessageArray)) {
        // Filter out only the message "cityId should not be empty"
        const filteredErrors = errorMessageArray.filter((msg) =>
          msg.includes("cityId should not be empty")
        );

        // If the specific error is found, replace "cityId" with "city" and display the modified message
        if (filteredErrors.length > 0) {
          const finalErrorMessage =
            filteredErrors[0].replace("cityId", "city") +
            ", " +
            errorMessageArray[0];
          // Display this message in the UI (alert, toast, or inline message)
          alert(finalErrorMessage);
        } else alert(`Error: ${errorMessageArray}`);
      } else {
        // Handle general errors
        alert("An unexpected error occurred: " + err.message);
      }
    }

    this.setState({ loading: false });
  };

  render() {
    const { loading, isLoading, name, city, citylist, id } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  {/* Render SelectRow only when adding (no id) */}
                  {!id && (
                    <SelectRow
                      label={strings.city}
                      name="cityId"
                      defaultValue={city}
                      data={citylist}
                      changeInput={this.changeInput.bind(this)}
                    />
                  )}

                  <FormRow
                    label={strings.name}
                    name="name"
                    data={name}
                    changeInput={this.changeInput}
                  />
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
